import { Button, Col, Form, Input, message, Modal, Row } from 'antd';
import React, { useState } from 'react';
import returnPRN, { returnPreviewPRN } from '../barcode/returnPRN';
import { ShowAllData } from '@/apiError/apiShow';
import { AntButton } from '@/common/ant-components/AntButton';

const PreviewPRNSelectFormat = ({
  extraDetails,
  summaryData,
  formReport,
  barcodeValues,
  barcodePrintFormats,
  isPreview,
  setIsPreview,
  form,
}) => {
  const [formD] = Form.useForm();
  const [prnData, setPrnData] = useState('');

  async function handlePrint(selectedBarcodeFormat, extraDetailsApi) {
    let printPreviewPRN = [];
    if (formReport) {
      printPreviewPRN = [
        returnPreviewPRN(
          selectedBarcodeFormat?.prnCode,
          barcodeValues,
          extraDetailsApi?.[0]?.itemName,
          0,
          extraDetailsApi,
          summaryData,
          form,
        ),
      ];
    } else {
      printPreviewPRN = barcodeValues?.map((barcodeValue, index) => {
        return returnPreviewPRN(
          selectedBarcodeFormat?.prnCode,
          barcodeValue,
          extraDetails?.[index]?.itemName,
          index,
          extraDetails,
          summaryData,
          form,
        );
      });
    }

    return printPreviewPRN;
  }

  const formatPreviewObject = (obj) => {
    const longestKeyLength = Math.max(
      ...Object.keys(obj).map((key) => key.length),
    );
    return Object.entries(obj)
      .map(([key, value]) => {
        const paddedKey = key.padEnd(longestKeyLength + 5, ' ');
        return `✔ ${paddedKey}: ${value}`;
      })
      .join('\n');
  };

  const handleSelect = async (format) => {
    try {
      let result;
      if (formReport) {
        const details = await ShowAllData.showDetails(
          `/transactions/item-details/print/?itemPrefix=${barcodeValues}`,
        );
        result = await handlePrint(format, [details.data.detailsData[0]]);
      } else {
        result = await handlePrint(format);
      }
      let prnString = result
        .map((item) => formatPreviewObject(item))
        .join(
          '\n*****************************************************************\n',
        );
      setPrnData(prnString);
      formD.setFieldsValue({ previewArea: prnString });
    } catch (error) {
      message.error(`Format Error:${error.message}`);
      console.error(error);
    }
  };

  const handleCancel = () => {
    setIsPreview(false);
    formD.setFieldsValue({ previewArea: '' });
  };

  return (
    <Modal
      title="Select Preview Format"
      open={isPreview}
      onCancel={handleCancel}
      onOk={handleCancel}
      width={600}
      footer={false}
    >
      <Form form={formD}>
        <Form.Item
          label="Select Format"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <Row gutter={[16, 16]}>
            {barcodePrintFormats.length > 0 ? (
              barcodePrintFormats.map((format, index) => (
                <Col key={index} span={5}>
                  <AntButton
                    block
                    onClick={() => handleSelect(format)}
                    // style={{ height: 40, whiteSpace: 'normal' }}
                  >
                    {format.heading}
                  </AntButton>
                </Col>
              ))
            ) : (
              <Col span={24}>
                <p className="text-red-500">
                  Format Not found. Please Configure from settings.
                </p>
              </Col>
            )}
          </Row>
        </Form.Item>

        <Form.Item
          label="PRN Preview"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="previewArea"
        >
          <Input.TextArea
            rows={10}
            readOnly
            value={prnData}
            style={{
              fontFamily: 'Courier New',
              fontWeight: 600,
              fontSize: '14px',
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PreviewPRNSelectFormat;
